import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/login/reload.png'


_pushScopeId("data-v-6c1e73c4")
const _hoisted_1 = { class: "weChat-login" }
const _hoisted_2 = {
  id: "weChatQrCode",
  ref: "weChatQrCode",
  class: "weChat-container"
}
const _hoisted_3 = {
  key: 0,
  class: "weChat-loading"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "weChat-loading-icon-container" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "weChat-loading-icon" })
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "weChat-loading-text" }, "加载中...", -1)
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = {
  key: 1,
  class: "weChat-error"
}
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, null, 512),
    (_ctx.showLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_6))
      : _createCommentVNode("", true),
    (_ctx.showError)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("img", {
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.reLoadWeChatQrCode && _ctx.reLoadWeChatQrCode(...args))),
            src: _imports_0,
            alt: ""
          }),
          _createElementVNode("div", null, _toDisplayString(_ctx.errorMessage.split(",")[0]), 1),
          _createElementVNode("div", null, _toDisplayString(_ctx.errorMessage.split(",")[1]), 1)
        ]))
      : _createCommentVNode("", true)
  ]))
}